import React from 'react';
import Button from '@atlaskit/button';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';
import { useIntl } from '@atlassian/jira-intl';
import {
	DELETE_MODAL_SELECTOR,
	DELETE_MODAL_SPINNER_SELECTOR,
	DELETE_MODAL_SUBMIT_BUTTON_SELECTOR,
} from '../../../common/constants';
import { messages } from './messages';

export type DeleteModalViewProps = {
	isSubmitting: boolean;
	schemeName: string;
	onComplete: () => void;
	onSubmit: () => void;
};

export const DeleteModalView = ({
	isSubmitting,
	schemeName,
	onComplete,
	onSubmit,
}: DeleteModalViewProps) => {
	const { formatMessage } = useIntl();
	const modalTitle = formatMessage(messages.deleteModalTitleWithNoAssociatedProject, {
		schemeName,
	});
	const modalDescription = formatMessage(messages.deleteModalDescriptionWithNoAssociatedProject);

	return (
		<Modal testId={DELETE_MODAL_SELECTOR} onClose={onComplete}>
			<ModalHeader>
				<ModalTitle appearance="warning">{modalTitle}</ModalTitle>
			</ModalHeader>
			<ModalBody>{modalDescription}</ModalBody>
			<ModalFooter>
				<Button appearance="subtle" onClick={onComplete} isDisabled={isSubmitting}>
					{formatMessage(messages.deleteModalCancelButtonTitle)}
				</Button>
				<Button
					testId={DELETE_MODAL_SUBMIT_BUTTON_SELECTOR}
					appearance="warning"
					onClick={onSubmit}
					isDisabled={isSubmitting}
					autoFocus
				>
					{isSubmitting ? (
						<Spinner size="small" testId={DELETE_MODAL_SPINNER_SELECTOR} />
					) : (
						formatMessage(messages.deleteModalDeleteButtonTitle)
					)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
